import { Component } from '@angular/core';

export interface Portfolio {
  img: string;
  title: string;
  categories: string[];
  alt: string;
}

@Component({
  selector: 'app-portfolio-two-column',
  templateUrl: './portfolio-one.component.html',
  styleUrl: './portfolio-one.component.css'
})
export class PortfolioTwoColumnComponent {
  // Portfolio Filter
  portfolioFilters = ['All', 'Branding', 'App Development', 'Animation', 'Marketing'];
  selectedFilter = 'All';
  
  portfolioItems: Portfolio[] = [
    {
      img: 'assets/images/portfolio/gallery-2.jpg',
      title: 'Creative Ideas',
      categories: ['branding', 'animation'],
      alt: 'gallery-1'
    },
    {
      img: 'assets/images/portfolio/gallery-20.jpg',
      title: 'Magic Touch',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-2'
    },
    {
      img: 'assets/images/portfolio/gallery-21.jpg',
      title: 'Data Analysis',
      categories: ['animation', 'branding'],
      alt: 'gallery-3'
    },
    {
      img: 'assets/images/portfolio/gallery-22.jpg',
      title: 'Data Analysis',
      categories: ['marketing', 'branding'],
      alt: 'gallery-4'
    },
    {
      img: 'assets/images/portfolio/gallery-23.jpg',
      title: 'Market Research',
      categories: ['app-development', 'branding'],
      alt: 'gallery-5'
    },
    {
      img: 'assets/images/portfolio/gallery-24.jpg',
      title: 'Illustration',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-6'
    }
  ];
  // Portfolio Filter End

  // Portfolio Filter Methods
  filterPortfolio(filter: string): void {
    this.selectedFilter = filter;
  }

  isPortfolioVisible(item: Portfolio): boolean {
    if (this.selectedFilter === 'All') {
      return true;
    }
    const selectedFilterLower = this.selectedFilter.toLowerCase().replace(/\s+/g, '-');
    return item.categories.includes(selectedFilterLower);
  }

  formatCategories(categories: string[]): string {
    return categories.join(', ').replace(/-/g, ' ');
  }
  // Portfolio Filter Methods End  
  
  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }  
}
